import CustomAlertThresholdFilter, {
  OnChangePayload,
  AlertSection,
} from '../CustomAlertThresholdFilter';
import { useAlertFilterDropDown } from '../hooks/useAlertFilterDropDown';

import type {
  AppliedFilter,
  SecondaryFilterOption,
} from '../../ControlTower/types';

type AlertsBodyProps = {
  selectedOptions: SecondaryFilterOption[];
  appliedFilters: AppliedFilter[];
  handleAlertThresholdSelect?: (payload: OnChangePayload) => void;
  searchQuery: string;
  hiddenOptionIds?: Set<string>;
  alertFilterConfigOverride?: AlertSection[];
};

const AlertsBody: React.FC<AlertsBodyProps> = ({
  selectedOptions,
  appliedFilters,
  handleAlertThresholdSelect,
  searchQuery,
  hiddenOptionIds,
  alertFilterConfigOverride,
}) => {
  // Skip API call if we have an override (Logiblocks case)
  const hookConfig = useAlertFilterDropDown(!!alertFilterConfigOverride);

  // Use override if provided (Logiblocks), otherwise use hook result (Control Tower)
  const configToUse = alertFilterConfigOverride ?? hookConfig;

  return (
    <CustomAlertThresholdFilter
      selectedOptions={selectedOptions.map((opt) => ({
        id: String(opt.id),
        name: opt.name,
      }))}
      appliedFilters={appliedFilters}
      onChange={handleAlertThresholdSelect ?? (() => {})}
      searchQuery={searchQuery}
      fullAlertFilterConfig={configToUse}
      hiddenOptionIds={hiddenOptionIds}
    />
  );
};

export default AlertsBody;
